export interface FeedbackButtonProps {
  id: string;
  floatingFeedbackButtonProps?: FloatingFeedbackButtonProps;
  onClick?: () => void;
  isStickingToRight?: boolean;
}

export interface FloatingFeedbackButtonProps {
  top?: number;
  bottom?: number | string;
  right?: number;
  left?: number;
}

export const EVENT_SURVEY_ID = 'event-feedback-hotjar';

export const shouldShowUserEventFeedbackSurvey = async (): Promise<boolean> => {
  try {
    return (await window.PMW.readLocal('event/shouldShowUserEventFeedbackSurvey')) as boolean;
  } catch (e) {
    console.error('error checking if should display feedback survey', e);
  }
  return false;
};

export const setUserCompletedEventSurvey = async (): Promise<void> => {
  try {
    await window.PMW.readLocal('event/markUserEventFeedbackSurveyComplete');
  } catch (e) {
    console.error('error marking event survey completed', e);
  }
}